let PYOItems = JSON.parse(localStorage.getItem('PYOItems')) || [];
let PYOAccessories = [];



let FreqItems = [];


let qtyChangeBtn = document.querySelectorAll('[data-qty-btn]');
let qtyIncreaseBtn = document.querySelectorAll('[data-increase-qty]');

let qtyInputs = document.querySelectorAll('[data-qty-input]');
let progressItems = document.querySelectorAll('.summary-progreebar .progress-item');
let progressItemsSticky = document.querySelectorAll('.sticky-progressbar .progress-item');


let checkoutBtn = document.querySelectorAll('[data-checkout-pack]');

let removeBtn = document.querySelectorAll('[data-remove-pack]')

function savePYOItems() {
    localStorage.setItem('PYOItems', JSON.stringify(PYOItems));
}
function syncPYOItemsFromInputs() {
    const syncedItems = [];

    document.querySelectorAll('[data-qty-container]').forEach((container) => {
        const input = container.querySelector('[data-qty-input]');
        if (!input) return;

        const quantity = parseInt(input.value, 10) || 0;

        if (quantity <= 0) return;

        const variantID = container.getAttribute('data-pro-variant');
        const imageSrc = container.getAttribute('data-pro-image');

        for (let i = 0; i < quantity; i++) {
            syncedItems.push({
                id: variantID,
                image_src: imageSrc,
                quantity: 1
            });
        }
    });

    PYOItems = syncedItems;
    savePYOItems();
}
let detch = document.querySelector('.image-popup');
if (detch !== null && detch !== undefined) {
  document.querySelector('body').appendChild(detch);
}

// let zoomImageEls = document.querySelectorAll('.pyo-products-selection .card-img img');

// zoomImageEls.forEach((img) => {
//   img.addEventListener('click', (event) => {
//     event.preventDefault();

//     // Get the data-img attribute directly from the closest anchor tag of the image
//     let zoomImageSrc = event.target.closest('.card').querySelector('a').getAttribute('data-img');
    
//     if (zoomImageSrc) {
//       document.querySelector('[data-zoom-img]').src = zoomImageSrc;
//       document.querySelector('.image-popup').classList.add('open');
//     }
//   });
// });

// // Function to close the popup
// function closePopup() {
//   document.querySelector('[data-zoom-img]').src = '';
//   document.querySelector('.image-popup').classList.remove('open');
// }

// // Close popup on clicking the close button
// document.querySelector('.close-image-popup').addEventListener('click', (event) => {
//   event.preventDefault();
//   closePopup();
// });

// // Close popup on clicking the overlay
// document.querySelector('.popup-overlay').addEventListener('click', () => {
//   closePopup();
// });




document.body.addEventListener('click', async (event) => {
    if (event.target.closest('.close-icon')) { 
        const button = event.target.closest('.close-icon');
        let variantID = button.getAttribute('data-remove-pack');
        

        // Remove item from PYOItems array
        const index = PYOItems.findIndex(item => item.id === variantID);
        if (index !== -1) {
            // Remove the item at the found index
            PYOItems.splice(index, 1);

            // Save updated array to localStorage
            localStorage.setItem('PYOItems', JSON.stringify(PYOItems));

            // Re-render selectionHTML to update the UI
            loadPYOItems();
        }
    }
});


async function loadPYOItems() {

       let html = selectionHTML();
        document.querySelector('[data-result-listing]').innerHTML = html;
        document.querySelectorAll('[data-qty-container]')?.forEach((container) => {
        const variantID = container.getAttribute('data-pro-variant');
        const qtyInput = container.querySelector('[data-qty-input]');

        // Count the occurrences of this variantID in the stored PYOItems
        const quantity = PYOItems.filter(item => item.id === variantID).length;

        if (quantity > 0) {
            // Set the quantity input value to the count
            qtyInput.value = quantity;
            container.classList.add('active');
        } else {
            // If no matching item, default to 'ADD'
            qtyInput.value = 'ADD';
            container.classList.remove('active');
        }

       

          let PYOLength = PYOItems.length;
           if(PYOLength >= 50){
              qtyIncreaseBtn.forEach((btn) => {
                  btn.classList.add('disabled')
              })
             qtyInputs.forEach((btn) => {
                  btn.classList.add('disabled')
              })
             
           } else if(PYOLength < 50){
              qtyIncreaseBtn.forEach((btn) => {
                  btn.classList.remove('disabled')
              })
             qtyInputs.forEach((btn) => {
                  btn.classList.remove('disabled')
              })
           }
          
            if(PYOLength > 0){
              checkoutBtn.forEach((button) => {
                button.classList.remove('disabled')
                button.removeAttribute('disabled')
              });
              document.querySelector('.pyo-sticky-sec .pyo-summary').classList.add('open');
              
            
            } else {
              checkoutBtn.forEach((button) => {
                button.classList.add('disabled')
                button.setAttribute('disabled','disabled')
              });
              document.querySelector('.pyo-sticky-sec .pyo-summary').classList.remove('open');
               
            }

          if(PYOLength >= 3){
            document.querySelectorAll('[data-qty-container-frq]').forEach(element => {
                element.classList.remove('lock-accessories-qty');
            });

            document.querySelectorAll('.unlock-accessories').forEach((el) => {
              el.classList.remove('d-none');
            });
            document.querySelectorAll('[data-lock-div]').forEach((el) => {
              el.classList.add('d-none');
            });
          } else {
            document.querySelectorAll('[data-qty-container-frq]').forEach(element => {
                element.classList.add('lock-accessories-qty');
            });

            document.querySelectorAll('.unlock-accessories').forEach((el) => {
              el.classList.add('d-none');
            });
            document.querySelectorAll('[data-lock-div]').forEach((el) => {
              el.classList.remove('d-none');
            });
          }

           let totalPrice = 0;
          let compareTotalPrice = 0
            
          const allQtyInputs = document.querySelectorAll('[data-qty-input]');

          const allAccInputs = document.querySelectorAll('[data-qty-input-frq]');
  
  
          allQtyInputs.forEach(input => {
              let proPrice = input.closest('[data-qty-container]').getAttribute('data-price');
              let comparePrice = input.closest('[data-qty-container]').getAttribute('data-compare-price');
      
              let qty = parseInt(input.value) || 0; // Get current quantity
              totalPrice += proPrice * qty; // Sum up total price
              compareTotalPrice += comparePrice * qty; // Sum up compare price
          });

             let accTotal = 0;
             let accCompareTotal = 0;
             allAccInputs.forEach(input => {
                let proaccPrice = input.closest('[data-qty-container-frq]').getAttribute('data-price');
                let compareaccPrice = input.closest('[data-qty-container-frq]').getAttribute('data-compare-price');
        
                let qty = parseInt(input.value) || 0; // Get current quantity
                let discountAccPrice = (proaccPrice * qty);
               
                accTotal += discountAccPrice;
                accCompareTotal += compareaccPrice * qty; // Sum up compare price
            });
        
             let formattedCPrice = `$${(compareTotalPrice / 100).toFixed(2)}`; // Divide by 100 and format to 2 decimal places
        
              if(compareTotalPrice > 0){
                document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = formattedCPrice;
              }
            
                          
              let formattedPrice;
              let formattedAccPrice;
              let discountPercentage = 0;
              let discountAccPercentage = 0;
             
              if (PYOLength >= 2 && PYOLength < 3) {
                discountPercentage = 11.5385;
              } else if (PYOLength >= 3 && PYOLength < 6) {
                discountPercentage = 33.33333333;
              } else if (PYOLength >= 6 && PYOLength < 9) {
                discountPercentage = 44.2308;
              } else if (PYOLength >= 9) {
                discountPercentage = 55;
              }
        
              if(PYOLength >= 3){
                discountAccPercentage = 40;
                
                document.querySelectorAll('.disocunt-normal-price').forEach((el) => {
                  el.classList.add('hidden');
                });
                document.querySelectorAll('.discount-accessories-price').forEach((el) => {
                  el.classList.remove('hidden');
                }); 
              } else {
                document.querySelectorAll('.disocunt-normal-price').forEach((el) => {
                  el.classList.remove('hidden');
                });
                document.querySelectorAll('.discount-accessories-price').forEach((el) => {
                  el.classList.add('hidden');
                }); 
              }
            
            
             
             
               let totalPriceInPence = Math.round(totalPrice);
       
                // Calculate discounted price
                let discountAmount = (totalPriceInPence * discountPercentage) / 100;
                
                let accessoriesDiscountAmount = (accTotal * discountAccPercentage) / 100;
          
                let finalDiscountAmount = discountAmount + accessoriesDiscountAmount;
                
          
                
          
                formattedAccPrice = (((accTotal / 100) - (accessoriesDiscountAmount / 100)).toFixed(2));
          
          
               //  formattedPrice = `£${(((totalPrice / 100) - (discountAmount / 100)) + Number(formattedAccPrice)).toFixed(2)}`;
               // console.log('number====>>>>>', formattedPrice);
          
          
               
let discountAmountInPence = Math.round(discountAmount);
let accessoriesDiscountAmountInPence = Math.round(accessoriesDiscountAmount);

let discountedBarsPriceInPence =
    totalPriceInPence - discountAmountInPence;

let discountedAccessoriesPriceInPence =
    accTotal - accessoriesDiscountAmountInPence;

let finalPriceInPence =
    discountedBarsPriceInPence + discountedAccessoriesPriceInPence;

formattedPrice = `£${(finalPriceInPence / 100).toFixed(2)}`;

          

          
              if(accTotal > 0){
                totalPrice += accTotal;
              }
               document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = `£${(totalPrice / 100).toFixed(2)}`;
              document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>£${(totalPrice / 100).toFixed(2)}`;
              document.querySelector('[data-save-amount]').innerHTML = `£${(finalDiscountAmount / 100).toFixed(2)}`;
              // Default case: full price
              if (PYOLength < 2) {
                formattedPrice = `£${(totalPrice / 100).toFixed(2)}`;
                // formattedPrice = `£${(totalPrice / 100).toFixed(2)}`;
                document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = '';
                document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>`;
              }
        
                      
        
        
             document.querySelector('[data-pack-price] [data-pack-price-total]').innerHTML = formattedPrice;
             document.querySelector('[data-total-price-pack]').innerHTML = formattedPrice;



          
                    
          
          
          
           
          
            if(PYOLength < 2){
              let left_count = 2 - PYOLength;
              document.querySelector('[data-got-offer]').classList.add('hide');
              document.querySelector('[data-second-offer]').classList.add('hide');
              document.querySelector('[data-third-offer]').classList.add('hide');
              document.querySelector('[data-fourth-offer]').classList.add('hide');
              document.querySelector('[data-first-offer]').classList.remove('hide');
              document.querySelector('[data-first-left]').innerHTML = `${left_count} ${left_count === 1 ? 'bar' : 'bars'}`;
            } else if(PYOLength >= 2 && PYOLength < 3){
              let left_count_second = 3 - PYOLength;
              document.querySelector('[data-got-offer]').classList.add('hide');
              document.querySelector('[data-second-offer]').classList.remove('hide');
              document.querySelector('[data-third-offer]').classList.add('hide');
              document.querySelector('[data-fourth-offer]').classList.add('hide');
              document.querySelector('[data-first-offer]').classList.add('hide');
              document.querySelector('[data-second-left]').innerHTML = `${left_count_second} ${left_count_second === 1 ? 'bar' : 'bars'}`;
          
            } else if(PYOLength >= 3 && PYOLength < 6){
              let left_count_third = 6 - PYOLength;
              document.querySelector('[data-got-offer]').classList.add('hide');
              document.querySelector('[data-second-offer]').classList.add('hide');
              document.querySelector('[data-third-offer]').classList.remove('hide');
              document.querySelector('[data-fourth-offer]').classList.add('hide');
              document.querySelector('[data-first-offer]').classList.add('hide');
              document.querySelector('[data-third-left]').innerHTML = `${left_count_third} ${left_count_third === 1 ? 'bar' : 'bars'}`;

            } else if(PYOLength >= 6 && PYOLength < 9){
              let left_count_fourth = 9 - PYOLength;
              document.querySelector('[data-got-offer]').classList.add('hide');
              document.querySelector('[data-second-offer]').classList.add('hide');
              document.querySelector('[data-third-offer]').classList.add('hide');
              document.querySelector('[data-fourth-offer]').classList.remove('hide');
              document.querySelector('[data-first-offer]').classList.add('hide');
              document.querySelector('[data-fourth-left]').innerHTML = `${left_count_fourth} ${left_count_fourth === 1 ? 'bar' : 'bars'}`;

            } else {
              document.querySelector('[data-got-offer]').classList.remove('hide')
              document.querySelector('[data-second-offer]').classList.add('hide');
              document.querySelector('[data-third-offer]').classList.add('hide');
              document.querySelector('[data-fourth-offer]').classList.add('hide');
              document.querySelector('[data-first-offer]').classList.add('hide');
          
          
            }



          // if(PYOLength < 5){
          //   document.querySelectorAll('.money.orginal_price').forEach((el) =>{
          //     el.classList.remove('price_over_5')
          //   });
          //    document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
          //     el.classList.remove('price_over_5')
          //   });
          //     document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
          //     el.style.display = 'block';
          //   });
          //    document.querySelectorAll('.money.orginal_price').forEach((el) =>{
          //     el.style.display = 'block';
          //   });
          // } else {
          //     document.querySelectorAll('.money.orginal_price').forEach((el) =>{
          //       el.classList.add('price_over_5')
          //     });
          //      document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
          //     el.classList.add('price_over_5')
          //   });
              
            
          // }


    



          
          
           progressItems.forEach(item => item.classList.remove('active'));
           for (let i = 0; i < PYOItems.length && i < progressItems.length; i++) {
              progressItems[i].classList.add('active');
           }
          
             progressItemsSticky.forEach(item => item.classList.remove('active'));
           for (let i = 0; i < PYOItems.length && i < progressItemsSticky.length; i++) {
              progressItemsSticky[i].classList.add('active');
           }
          
    });
   
}

loadPYOItems();


qtyChangeBtn.forEach((button) => {
    button.addEventListener('click', (event) => {
        event.preventDefault();
        manageQtyBtn(event)
        let inputs = event.target.closest('.pro-product-listing').querySelectorAll('[data-qty-container] a');
        inputs.forEach(input => {
            input.classList.add('disabled'); 
        });

      setTimeout(() => {
        inputs.forEach(input => {
            input.classList.remove('disabled'); 
        });
      },2000)
    
    });
});

qtyInputs.forEach((input) => {
    input.addEventListener('click', (event) => {
        event.preventDefault();

        if (input.value === 'ADD') {
            // Find the associated increase button
            const increaseButton = input.closest('[data-qty-container]').querySelector('[data-increase-qty]');
            if (increaseButton) {
                // Directly call the click method instead of dispatching a synthetic event
                increaseButton.click();
            }
        }
    });
});






function manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
   
    let action = currentTarget.dataset.for;
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let qtyInputVal = parseInt($qtyInput.value);
    let currentQty = 0;
    if (!isNaN(qtyInputVal)) {
        currentQty = qtyInputVal;
    }
    //let currentQty = parseInt($qtyInput.value) || 0;
    let finalQty = 1;
    let variantID = currentTarget.closest('[data-qty-container]').getAttribute('data-pro-variant');
    let imageSrc = currentTarget.closest('[data-qty-container]').getAttribute('data-pro-image');

    let totalPrice = 0;
    let compareTotalPrice = 0

    if(action == 'decrease'){
      finalQty = currentQty - 1;
      clearItem(variantID,finalQty)
    } else {
      finalQty = currentQty + 1;
      // addItem(variantID,1);

    }
  
    

    if(finalQty < 1){
      $qtyInput.value = 'ADD';
      currentTarget.closest('[data-qty-container]').classList.remove('active');
    } else {
      $qtyInput.value = finalQty;
      currentTarget.closest('[data-qty-container]').classList.add('active');
    }
    const allQtyInputs = document.querySelectorAll('[data-qty-input]');
    const allAccInputs = document.querySelectorAll('[data-qty-input-frq]');

      allQtyInputs.forEach(input => {
        let proPrice = input.closest('[data-qty-container]').getAttribute('data-price');
        let comparePrice = input.closest('[data-qty-container]').getAttribute('data-compare-price');

        let qty = parseInt(input.value) || 0; // Get current quantity
        totalPrice += proPrice * qty; // Sum up total price
        compareTotalPrice += comparePrice * qty; // Sum up compare price
    });

     let accTotal = 0;
     let accCompareTotal = 0;
     allAccInputs.forEach(input => {
        let proaccPrice = input.closest('[data-qty-container-frq]').getAttribute('data-price');
        let compareaccPrice = input.closest('[data-qty-container-frq]').getAttribute('data-compare-price');

        let qty = parseInt(input.value) || 0; // Get current quantity
        let discountAccPrice = (proaccPrice * qty);
       
        accTotal += discountAccPrice;
        accCompareTotal += compareaccPrice * qty; // Sum up compare price
    });

  console.log('accTotal====>>>>',accTotal);

 



    managePYOSelection(action,variantID,imageSrc,totalPrice,compareTotalPrice,accTotal,accCompareTotal,finalQty);
}

async function managePYOSelection(action,variantID,imageSrc,totalPrice,compareTotalPrice,accTotal,accCompareTotal,finalQty){

    syncPYOItemsFromInputs();
console.log('===== BUNDLE DEBUG =====');
console.log('Bars:', PYOItems.length);
console.log('Bar items:', PYOItems);

const debugAccInputs = document.querySelectorAll('[data-qty-input-frq]');

console.log(
  'Accessory inputs:',
  Array.from(debugAccInputs).map(input => ({
    value: input.value,
    variant: input.closest('[data-qty-container-frq]')?.getAttribute('data-pro-variant'),
    price: input.closest('[data-qty-container-frq]')?.getAttribute('data-price')
  }))
);

console.log('Accessory total:', accTotal);
console.log('========================');
    let PYOLength = PYOItems.length;;
 if(PYOLength >= 50){
    qtyIncreaseBtn.forEach((btn) => {
        btn.classList.add('disabled')
    })
   qtyInputs.forEach((btn) => {
        btn.classList.add('disabled')
    })
   
 } else if(PYOLength < 50){
    qtyIncreaseBtn.forEach((btn) => {
        btn.classList.remove('disabled')
    })
   qtyInputs.forEach((btn) => {
        btn.classList.remove('disabled')
    })
 }

   if(PYOLength >= 3){
      document.querySelectorAll('[data-qty-container-frq]').forEach(element => {
          element.classList.remove('lock-accessories-qty');
      });

      document.querySelectorAll('.unlock-accessories').forEach((el) => {
        el.classList.remove('d-none');
      });
      document.querySelectorAll('[data-lock-div]').forEach((el) => {
        el.classList.add('d-none');
      });
      document.querySelectorAll('.disocunt-normal-price').forEach((el) => {
        el.classList.add('hidden');
      });
      document.querySelectorAll('.discount-accessories-price').forEach((el) => {
        el.classList.remove('hidden');
      }); 
     
    } else {
      document.querySelectorAll('[data-qty-container-frq]').forEach(element => {
          element.classList.add('lock-accessories-qty');
      });
     

      document.querySelectorAll('.unlock-accessories').forEach((el) => {
        el.classList.add('d-none');
      });
      document.querySelectorAll('[data-lock-div]').forEach((el) => {
        el.classList.remove('d-none');
      });

      document.querySelectorAll('.disocunt-normal-price').forEach((el) => {
        el.classList.remove('hidden');
      });
      document.querySelectorAll('.discount-accessories-price').forEach((el) => {
        el.classList.add('hidden');
      }); 

      let PYOAccessories = [];

    }


    

 // if(PYOLength < 5){
 //    document.querySelectorAll('.money.orginal_price').forEach((el) =>{
 //      el.classList.remove('price_over_5')
 //    });
 //   document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
 //      el.classList.remove('price_over_5')
 //    });
 //     document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
 //      el.style.display = 'block';
 //    });
 //     document.querySelectorAll('.money.orginal_price').forEach((el) =>{
 //      el.style.display = 'block';
 //    });
 //  } else {
 //      document.querySelectorAll('.money.orginal_price').forEach((el) =>{
 //        el.classList.add('price_over_5')
 //      });
 //       document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
 //      el.classList.add('price_over_5')
 //    });
    
 //  }


    
    

  if(PYOLength > 0){
    checkoutBtn.forEach((button) => {
      button.classList.remove('disabled')
      button.removeAttribute('disabled')
    });
    document.querySelector('.pyo-sticky-sec .pyo-summary').classList.add('open');
  } else {
    checkoutBtn.forEach((button) => {
      button.classList.add('disabled')
      button.setAttribute('disabled','disabled')
    });
    document.querySelector('.pyo-sticky-sec .pyo-summary').classList.remove('open');
  }


     let formattedCPrice = `$${(compareTotalPrice / 100).toFixed(2)}`; // Divide by 100 and format to 2 decimal places

      if(compareTotalPrice > 0){
        document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = formattedCPrice;
      }
    
                  
      let formattedPrice;
      let formattedAccPrice;
      let discountPercentage = 0;
      let discountAccPercentage = 0;
    
      if (PYOLength >= 2 && PYOLength < 3) {
        discountPercentage = 11.5385;
      } else if (PYOLength >= 3 && PYOLength < 6) {
        discountPercentage = 33.33333333;
      } else if (PYOLength >= 6 && PYOLength < 9) {
        discountPercentage = 44.2308;
      } else if (PYOLength >= 9) {
        discountPercentage = 55;
      }

      if(PYOLength >= 3){
        discountAccPercentage = 40;
      }
    
    
      let totalPriceInPence = Math.round(totalPrice);

      let totalPriceWithAcc =  Math.round(totalPrice) +  Math.round(accTotal);
       
      // Calculate discounted price
      let discountAmount = (totalPriceInPence * discountPercentage) / 100;
      
      let accessoriesDiscountAmount = (accTotal * discountAccPercentage) / 100;

      let finalDiscountAmount = discountAmount + accessoriesDiscountAmount;
      

      

      //formattedAccPrice = (((accTotal / 100) - (accessoriesDiscountAmount / 100)).toFixed(2));


     //  formattedPrice = `£${(((totalPrice / 100) - (discountAmount / 100)) + Number(formattedAccPrice)).toFixed(2)}`;
     // console.log('number====>>>>>', formattedPrice);


     
      // Convert main price components to pence
      let discountAmountInPence = Math.round(discountAmount);
      let finalPriceInPence = totalPriceInPence - discountAmountInPence;
      
      // Calculate accessories price in pence
      let formattedAccPriceInPence = Math.round(((accTotal / 100) - (accessoriesDiscountAmount / 100)) * 100);
      
      // Add accessories price to the final price
      finalPriceInPence += formattedAccPriceInPence;
      
      // Convert back to pounds and format
      formattedPrice = `£${(finalPriceInPence / 100).toFixed(2)}`;
      
      console.log('formattedPrice:', formattedPrice);

      
      
      if(accTotal > 0){
        totalPrice += accTotal;
      }
       document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = `£${(totalPriceWithAcc / 100).toFixed(2)}`;
      document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>£${(totalPriceWithAcc / 100).toFixed(2)}`;
      document.querySelector('[data-save-amount]').innerHTML = `£${(finalDiscountAmount / 100).toFixed(2)}`;
      // Default case: full price
      if (PYOLength < 2) {
        
        formattedPrice = `£${(totalPrice / 100).toFixed(2)}`;
        document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = '';
        document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>`;
      }

              


     document.querySelector('[data-pack-price] [data-pack-price-total]').innerHTML = formattedPrice;
     document.querySelector('[data-total-price-pack]').innerHTML = formattedPrice;


  
          
  if(PYOLength < 2){
    let left_count = 2 - PYOLength;
    document.querySelector('[data-got-offer]').classList.add('hide');
    document.querySelector('[data-second-offer]').classList.add('hide');
    document.querySelector('[data-third-offer]').classList.add('hide');
    document.querySelector('[data-fourth-offer]').classList.add('hide');
    document.querySelector('[data-first-offer]').classList.remove('hide');
    document.querySelector('[data-first-left]').innerHTML = `${left_count} ${left_count === 1 ? 'bar' : 'bars'}`;
  } else if(PYOLength >= 2 && PYOLength < 3){
    let left_count_second = 3 - PYOLength;
    document.querySelector('[data-got-offer]').classList.add('hide');
    document.querySelector('[data-second-offer]').classList.remove('hide');
    document.querySelector('[data-third-offer]').classList.add('hide');
    document.querySelector('[data-fourth-offer]').classList.add('hide');
    document.querySelector('[data-first-offer]').classList.add('hide');
    document.querySelector('[data-second-left]').innerHTML = `${left_count_second} ${left_count_second === 1 ? 'bar' : 'bars'}`;

  } else if(PYOLength >= 3 && PYOLength < 6){
    let left_count_third = 6 - PYOLength;
    document.querySelector('[data-got-offer]').classList.add('hide');
    document.querySelector('[data-second-offer]').classList.add('hide');
    document.querySelector('[data-third-offer]').classList.remove('hide');
    document.querySelector('[data-fourth-offer]').classList.add('hide');
    document.querySelector('[data-first-offer]').classList.add('hide');
    document.querySelector('[data-third-left]').innerHTML = `${left_count_third} ${left_count_third === 1 ? 'bar' : 'bars'}`;

  } else if(PYOLength >= 6 && PYOLength < 9){
    let left_count_fourth = 9 - PYOLength;
    document.querySelector('[data-got-offer]').classList.add('hide');
    document.querySelector('[data-second-offer]').classList.add('hide');
    document.querySelector('[data-third-offer]').classList.add('hide');
    document.querySelector('[data-fourth-offer]').classList.remove('hide');
    document.querySelector('[data-first-offer]').classList.add('hide');
    document.querySelector('[data-fourth-left]').innerHTML = `${left_count_fourth} ${left_count_fourth === 1 ? 'bar' : 'bars'}`;

  } else {
    document.querySelector('[data-got-offer]').classList.remove('hide')
    document.querySelector('[data-second-offer]').classList.add('hide');
    document.querySelector('[data-third-offer]').classList.add('hide');
    document.querySelector('[data-fourth-offer]').classList.add('hide');
    document.querySelector('[data-first-offer]').classList.add('hide');


  }

 progressItems.forEach(item => item.classList.remove('active'));
 for (let i = 0; i < PYOItems.length && i < progressItems.length; i++) {
    progressItems[i].classList.add('active');
 }

   progressItemsSticky.forEach(item => item.classList.remove('active'));
 for (let i = 0; i < PYOItems.length && i < progressItemsSticky.length; i++) {
    progressItemsSticky[i].classList.add('active');
 }


  

 var html = await selectionHTML();
 document.querySelector('[data-result-listing]').innerHTML = html;

}

function removeFirstProductById(id) {
    const index = PYOItems.findIndex(item => item.id === id);
    if (index !== -1) {
        PYOItems.splice(index, 1);
    }
}

function selectionHTML(){

  const totalItems = 9;
  let selectedProductHTML = '';

  const defaultDivCount = totalItems - PYOItems.length;


    let combinedItemCount = 0; // Track the combined index
  // First, iterate over PYOItems
  PYOItems.forEach((item) => {
      if (combinedItemCount === 1) {
          // HTML for the 5th item
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <span class="close-icon" data-remove-pack="${item.id}">
                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                            <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                          </svg>
                      </span>
                      <div data-selected-item-image class="item-selected">
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      } else if (combinedItemCount === 2) {
          // HTML for the 5th item
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <span class="close-icon" data-remove-pack="${item.id}">
                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                            <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                          </svg>
                      </span>
                      <div data-selected-item-image class="item-selected">
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      }  else if (combinedItemCount === 5) {
          // HTML for the 5th item
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <span class="close-icon" data-remove-pack="${item.id}">
                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                            <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                          </svg>
                      </span>
                      <div data-selected-item-image class="item-selected">
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      } else if (combinedItemCount === 8) {
          // HTML for the 10th item
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <span class="close-icon" data-remove-pack="${item.id}">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                          <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                          <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                        </svg>
                      </span>
                  
                      <div data-selected-item-image class="item-selected">
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      } else {
          // Default HTML for other PYOItems
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                       <span class="close-icon" data-remove-pack="${item.id}">
                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                            <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                          </svg>
                      </span>
                      <div data-selected-item-image class="item-selected">
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      }
      combinedItemCount++; // Increment combined count
  });

  // Then, add default items up to `defaultDivCount`
  for (let i = 0; i < defaultDivCount; i++) {
      if (combinedItemCount === 1) {
          // HTML for the 5th item (if in default)
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <div class="offer-tag"><span>Save 12%</span></div>
                      <div class="svg-image" data-selected-item-image>
                      <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" fill="#737373"/>
                      <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" stroke="#737373" stroke-width="0.745983" stroke-dasharray="1.49 1.49"/>
                      </svg>


                    </div>
                  </div>
              </div>
          `;
      }
      else if (combinedItemCount === 2) {
          // HTML for the 5th item (if in default)
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <div class="offer-tag"><span>Save 33%</span></div>
                      <div class="svg-image" data-selected-item-image>
                      <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" fill="#737373"/>
                      <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" stroke="#737373" stroke-width="0.745983" stroke-dasharray="1.49 1.49"/>
                      </svg>


                    </div>
                  </div>
              </div>
          `;
      } else if (combinedItemCount === 5) {
          // HTML for the 10th item (if in default)
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <div class="offer-tag"><span>save 44%</span></div>
                      <div class="svg-image" data-selected-item-image>
                         <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" fill="#737373"/>
                          <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" stroke="#737373" stroke-width="0.745983" stroke-dasharray="1.49 1.49"/>
                          </svg>


                      </div>
                  </div>
              </div>
          `;
      } else if (combinedItemCount === 8) {
          // HTML for the 10th item (if in default)
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <div class="offer-tag"><span>save 55%</span></div>
                      <div class="svg-image" data-selected-item-image>
                        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" fill="#737373"/>
                        <rect x="1.02143" y="0.997015" width="70.4982" height="70.4982" rx="4.03841" stroke="#737373" stroke-width="0.745983" stroke-dasharray="1.49 1.49"/>
                        </svg>


                      </div>
                  </div>
              </div>
          `;
      } else {
          // Default HTML for other default items
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                       <div class="svg-image" data-selected-item-image>
                          <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="1.02143" y="0.752874" width="70.4982" height="70.4982" rx="4.03841" fill="#F1F1F1"/>
                          <rect x="1.02143" y="0.752874" width="70.4982" height="70.4982" rx="4.03841" stroke="#737373" stroke-width="0.745983" stroke-dasharray="1.49 1.49"/>
                          </svg>

                      </div>
                  </div>
              </div>
          `;
      }
      combinedItemCount++; // Increment combined count
  }
  

   

   

  return selectedProductHTML;

}



// function addItem(variantID,finalQty){
//   let formData = {
//      id: variantID,
//      quantity: finalQty
//   };

//   // Make the POST request to add items to the cart
//   fetch(window.Shopify.routes.root + 'cart/add.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(formData)
//   })
//   .then(response => {
//     if (response.ok) {
//       // Redirect to checkout on successful response
//       //location.href = '/checkout';
//     } else {
//       console.error('Failed to add items to cart:', response);
//     }
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
// }

// function removeItem(variantID,qty) {
//   let formData = {
//     id: variantID,
//     quantity: qty
//   };

//   console.log(formData);

//   // Make the POST request to remove item from the cart
//   fetch(window.Shopify.routes.root + 'cart/change.js', {
//     method: 'POST',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     body: JSON.stringify(formData)
//   })
//   .then(response => {
//     if (response.ok) {
//       console.log('Item successfully removed from cart');
//     } else {
//       console.error('Failed to remove item from cart:', response);
//     }
//   })
//   .catch((error) => {
//     console.error('Error:', error);
//   });
// }




// Select the elements
const pyoPage = document.querySelector('.pyo-page');
const stickySteps = document.querySelector('.sticky-steps');

// Create an intersection observer
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            // Remove the class when pyo-page is not in the viewport
            stickySteps.classList.remove('hide');
        } else {
            // Optionally, add the class back if needed
            stickySteps.classList.add('hide');
        }
    });
}, {
    threshold: 0 // Adjust this threshold as needed
});

// Start observing the pyo-page element
if (pyoPage) {
    observer.observe(pyoPage);
}



// iOS-safe scroll lock (prevents body scroll + touchmove)
const ScrollLock = (() => {
  let active = false;
  let sx = 0, sy = 0;

  const prevent = (e) => e.preventDefault();
  const blockKeys = (e) => {
    // space, pageUp, pageDown, end, home, arrows
    if ([32,33,34,35,36,37,38,39,40].includes(e.keyCode)) e.preventDefault();
  };

  function lock() {
    if (active) return;
    active = true;

    // store current scroll
    sx = window.pageXOffset || document.documentElement.scrollLeft || 0;
    sy = window.pageYOffset || document.documentElement.scrollTop || 0;

    // freeze body (works on iOS)
    const b = document.body;
    b.style.position = 'fixed';
    b.style.top = `-${sy}px`;
    b.style.left = `-${sx}px`;
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';

    // kill native scroll while locked
    document.addEventListener('touchmove', prevent, { passive: false, capture: true });
    document.addEventListener('wheel',     prevent, { passive: false, capture: true });
    document.addEventListener('keydown',   blockKeys, { capture: true });
  }

  function unlock() {
    if (!active) return;
    active = false;

    document.removeEventListener('touchmove', prevent, { capture: true });
    document.removeEventListener('wheel',     prevent, { capture: true });
    document.removeEventListener('keydown',   blockKeys, { capture: true });

    const b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';

    // restore scroll
    window.scrollTo(sx, sy);
  }

  // Lock, run fn, then unlock after DOM settles (2 frames)
  function withLock(fn) {
    lock();
    try { fn(); } finally {
      requestAnimationFrame(() => requestAnimationFrame(unlock));
    }
  }

  return { lock, unlock, withLock };
})();

let qtyChangeFrqBtn = document.querySelectorAll('[data-qty-btn-frq]');

qtyChangeFrqBtn.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      manageQtyFrqBtn(event)
    });
});

function callIncreaseHandler(el) {
  // Reuse your existing handler without synthetic clicks
  manageQtyFrqBtn({
    target: el,
    currentTarget: el,
    preventDefault() {},
    stopPropagation() {}
  });
}

let qtyInputsFrq = document.querySelectorAll('[data-qty-input-frq]');

qtyInputsFrq.forEach((input) => {
  input.addEventListener('click', (event) => {
    if (input.value === 'ADD') {
      event.preventDefault();
      event.stopPropagation();
      const increaseButton = input.closest('[data-qty-container-frq]')
                                  .querySelector('[data-increase-qty]');
      if (increaseButton) {
        ScrollLock.withLock(() => {
          callIncreaseHandler(increaseButton);
        });
      }
    }
  }, { passive: false });
});


// qtyInputsFrq.forEach((input) => {
//     input.addEventListener('click', (event) => {
//         if (input.value === 'ADD') {
//             event.preventDefault();
//             event.stopPropagation();
//             // Find the associated increase button
//             const increaseButton = input.closest('[data-qty-container-frq]').querySelector('[data-increase-qty]');
//             // if (increaseButton) {
//             //     // Directly call the click method instead of dispatching a synthetic event
//             //     increaseButton.click();
//             // }
//             if (increaseButton) {
//               const ev = new MouseEvent('click', {
//                 bubbles: true,
//                 cancelable: true,
//                 view: window
//               });
//               increaseButton.dispatchEvent(ev); // fires your listeners, no focus jump
//             }
//         }
//     });
// });

function manageQtyFrqBtn(event) {
    event.preventDefault();
    event.stopPropagation();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for;
    let $qtyInput = currentTarget.closest('[data-qty-container-frq]').querySelector('[data-qty-input-frq]');

    // Ensure the input value is a valid number
    let qtyInputVal = parseInt($qtyInput.value, 10) || 0;
   

    let currentQty = qtyInputVal;
    let finalQty = 1;
    let variantID = currentTarget.closest('[data-qty-container-frq]').getAttribute('data-pro-variant');

    // let PYOLength = PYOItems.length;
    let totalPrice = 0;
    let compareTotalPrice = 0;

    if (action === 'decrease') {
        finalQty = Math.max(0, currentQty - 1); // Prevent negative values
    } else {
        finalQty = currentQty + 1;
    }
  

    if(finalQty < 1){
      $qtyInput.value = 'ADD';
      currentTarget.closest('[data-qty-container-frq]').classList.remove('active');
    } else {
      $qtyInput.value = finalQty;
      currentTarget.closest('[data-qty-container-frq]').classList.add('active');
    }

   
    // $qtyInput.value = finalQty;
    const allQtyInputs = document.querySelectorAll('[data-qty-input]');
    const allAccInputs = document.querySelectorAll('[data-qty-input-frq]');

      allQtyInputs.forEach(input => {
        let proPrice = input.closest('[data-qty-container]').getAttribute('data-price');
        let comparePrice = input.closest('[data-qty-container]').getAttribute('data-compare-price');

        let qty = parseInt(input.value) || 0; // Get current quantity
        totalPrice += proPrice * qty; // Sum up total price
        compareTotalPrice += comparePrice * qty; // Sum up compare price
    });


     let accTotal = 0;
     let accCompareTotal = 0;
     allAccInputs.forEach(input => {
        let proaccPrice = input.closest('[data-qty-container-frq]').getAttribute('data-price');
        let compareaccPrice = input.closest('[data-qty-container-frq]').getAttribute('data-compare-price');

        let qty = parseInt(input.value) || 0; // Get current quantity
        let discountAccPrice = (proaccPrice * qty);
       
        accTotal += discountAccPrice;
        accCompareTotal += compareaccPrice * qty; // Sum up compare price
    });

     let formattedCPrice = `$${(compareTotalPrice / 100).toFixed(2)}`; // Divide by 100 and format to 2 decimal places

      if(compareTotalPrice > 0){
        document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = formattedCPrice;
      }
    
                  
      let formattedPrice;
      let formattedAccPrice;
      let discountPercentage = 0;
      let discountAccPercentage = 0;
      let PYOLength = PYOItems.length;
      if (PYOLength >= 2 && PYOLength < 3) {
        discountPercentage = 11.5385;
      } else if (PYOLength >= 3 && PYOLength < 6) {
        discountPercentage = 33.33333333;
      } else if (PYOLength >= 6 && PYOLength < 9) {
        discountPercentage = 44.2308;
      } else if (PYOLength >= 9) {
        discountPercentage = 55;
      }

      if(PYOLength >= 3){
        discountAccPercentage = 40;
      }
    

      let totalPriceInPence = Math.round(totalPrice);
        //let totalPriceWithAcc =  Math.round(totalPrice) +  Math.round(accTotal);
      // Calculate discounted price
      let discountAmount = (totalPriceInPence * discountPercentage) / 100;
      
      let accessoriesDiscountAmount = (accTotal * discountAccPercentage) / 100;

      let finalDiscountAmount = discountAmount + accessoriesDiscountAmount;
      

      

       formattedAccPrice = (((accTotal / 100) - (accessoriesDiscountAmount / 100)).toFixed(2));


       formattedPrice = `£${((Math.round(totalPrice) - Math.round(discountAmount)) / 100 + Math.floor(Number(formattedAccPrice) * 100) / 100).toFixed(2)}`;
     // console.log('number====>>>>>', formattedPrice);


     
      // let discountAmountInPence = Math.round(discountAmount);
      // let finalPriceInPence = totalPriceInPence - discountAmountInPence;
  
      // formattedPrice = `£${(finalPriceInPence / 100).toFixed(2)}`;

  
      
     if(accTotal > 0){
      totalPrice += accTotal;
     }
     document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = `£${(totalPrice / 100).toFixed(2)}`;
     document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>£${(totalPrice / 100).toFixed(2)}`;
      document.querySelector('[data-save-amount]').innerHTML = `£${(finalDiscountAmount / 100).toFixed(2)}`;
      // Default case: full price
      if (PYOLength < 2) {
       

        formattedPrice = `£${(totalPrice / 100).toFixed(2)}`;


        document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = '';
        document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>`;
      }

              


     document.querySelector('[data-pack-price] [data-pack-price-total]').innerHTML = formattedPrice;
     document.querySelector('[data-total-price-pack]').innerHTML = formattedPrice;

    manageFrqSelection(action, variantID, finalQty);
}

function manageFrqSelection(action,variantID,finalQty){
   if(action === 'decrease'){
      removeFirstProductById(variantID);
   } else {
      let product = {
          "id":variantID,
          "quantity":finalQty
      }
      PYOAccessories.push(product);
   }
  
}
function clearItem(id) {
    const index = PYOItems.findIndex(item => item.id === id);
    
    if (index !== -1) {
        if (PYOItems[index].quantity > 1) {
            PYOItems[index].quantity -= 1;  // Decrease quantity by 1
        } else {
            PYOItems.splice(index, 1);  // Remove item if quantity becomes 0
        }
    }
}


function removeFirstProductById(id) {
    const index = PYOAccessories.findIndex(item => item.id === id);
    if (index !== -1) {
        PYOAccessories.splice(index, 1);
    }
}
document.querySelector('.open-accessories')?.addEventListener('click', () => {
    document.querySelector('.accessories-content')?.classList.toggle('open');

    let mainHeading = document.querySelector('.main-heading');
    if (mainHeading) {
        mainHeading.classList.toggle('active');
        mainHeading.textContent = mainHeading.classList.contains('active') 
            ? "close all accessories" 
            : "choose your accessories";
    }

    // Toggle d-none class on icons
    document.querySelector('.open-access')?.classList.toggle('d-none');
    document.querySelector('.close-access')?.classList.toggle('d-none');
});

let isAddingToBag = false;
  document.querySelectorAll('[data-checkout-pack]').forEach((checkoutButton) => {
    checkoutButton.addEventListener('click', (event) => {
      event.preventDefault();


      if (isAddingToBag || checkoutButton.classList.contains('disabled')) {
        return;
      }


      if (PYOItems.length === 0) {
        return;
      }

      isAddingToBag = true;
      const allCheckoutBtns = document.querySelectorAll('[data-checkout-pack]');
      allCheckoutBtns.forEach((btn) => {
        btn.classList.add('is-loading', 'disabled');
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-busy', 'true');
      });

      let itemsMap = {};
      function addItemsToMap(array) {
        array.forEach((item) => {
          let itemID = item.id;
          let quantity = 1;
          if (itemsMap[itemID]) {
            itemsMap[itemID].quantity += quantity;
          } else {
            itemsMap[itemID] = { id: itemID, quantity: quantity };
          }
        });
      }

      addItemsToMap(PYOItems);
      addItemsToMap(PYOAccessories);

      let items = Object.values(itemsMap);
      let formData = { items: items };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })
    .then(response => response.json())
.then(data => {
  setTimeout(() => {
    console.log('Refreshing cart after Discount Ninja...');
    updateCartPanel(null, true);
  }, 700);
  console.log('Bundle added to Shopify. Waiting for Discount Ninja...');
})
      .catch((error) => {
        console.error('Error:', error);
      })
        .finally(() => {
          // Chahe success ho ya fail -> button wapas normal
          isAddingToBag = false;
          allCheckoutBtns.forEach((btn) => {
            btn.classList.remove('is-loading', 'disabled');
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-busy');
          });
        });
    });
  });

var sideCartContainer, countElement, cartPageContainer, cartPageTemplate;

 sideCartContainer = document.getElementById('cart');
countElement = document.getElementById('cart-count');
cartPageContainer = document.querySelector('form.form-cart, .cart-empty');
if (cartPageContainer != null) { // when there is an cart form, initialize the ajax cart for the inputs in the form
    cartPageContainer = cartPageContainer.parentElement;
    cartPageTemplate = cartPageContainer.id.replace('shopify-section-', '');
    handleCartUpdates(cartPageContainer);
}
function updateCartPanel(src, callback) {
  	fetch(window.Shopify.routes.root + "?section_id=side-cart")
				.then((response) => {
					if (!response.ok) {
						var error = new Error(response.status);
						throw error;
					}
					return response.text();
				})
				.then((text) => {
					const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-side-cart').innerHTML;
					handleCartPanel(resultsMarkup, true, false);
          requestAnimationFrame(() => {
  document.dispatchEvent(
    new CustomEvent('la:dn:drawercart:opened')
  );
});
				})
				.catch((error) => {
					console.log("updateCartPanel error", error);
					throw error;
				});
}

	function handleCartUpdates(container) {
		var updateItemInput = container.querySelectorAll('input[name="updates[]"]'),
			removeItemLink 	= container.getElementsByClassName('remove-from-cart-link'),
				noteElement = container.querySelector('textarea[name="note"]'),
				submitButtons = container.querySelectorAll('.link-btn a, .link-btn button');

		Array.from(updateItemInput).forEach(function (input) {
			input.addEventListener('change', function (e) {
				updateItemQty(e.target, container);
			});
		});

		Array.from(removeItemLink).forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				removeItem(e.target, container);
			});
		});

		if (noteElement) {
			// Debounced function to handle the input event
			const debouncedAddNote = debounce(async function (e) {
				try {
					await addNote(e.target, container);
					submitButtons.forEach(button => {
						button.disabled = false;
						button.classList.remove('disabled');
					});
					noteElement.focus();
				} catch (error) {
					console.error('Error:', error);
				}
			}, 1000);

			noteElement.addEventListener('input', function (e) {
				submitButtons.forEach(button => {
					button.disabled = true;
					button.classList.add('disabled');
				});
				debouncedAddNote(e);
			});
		}
		function debounce(func, delay) {
			let timeout;
			return function (...args) {
				clearTimeout(timeout);
				timeout = setTimeout(() => func.apply(this, args), delay);
			};
		}
	}

function handleCartPanel(resultsMarkup, openCartPanel,undoRemove){
console.log(resultsMarkup);
  let items = sideCartContainer.querySelectorAll('.l4ca > li');
  sideCartContainer.innerHTML = resultsMarkup;
  Array.from(items).forEach(function (item, index) {
      if (item.classList.contains('removing')) {
          if (undoRemove && sideCartContainer.querySelectorAll('.l4ca > li')[(index + 1)]) {
              sideCartContainer.querySelector('.l4ca').insertBefore(item, sideCartContainer.querySelectorAll('.l4ca > li')[(index + 1)]);
          } else if (undoRemove ) {
              sideCartContainer.querySelector('.l4ca').append(item);
          } else {
              sideCartContainer.querySelector('.l4ca').insertBefore(item, sideCartContainer.querySelectorAll('.l4ca > li')[(index)]);
          }
          if (sideCartContainer.querySelector('.empty:not(.hidden)')) {
              sideCartContainer.querySelector('.empty').classList.add('hidden');
          }
      }
  });

  if (sideCartContainer.querySelector('.product-recommendations:not(.product-recommendations-initialized)')) {
      window.dispatchEvent(recommendedProductsEvt);
  }
  window.dispatchEvent(modulePanelEvt);
  window.dispatchEvent(listCartEvt);
  window.dispatchEvent(semanticInputEvt);
  handleCartUpdates(sideCartContainer);
  window.dispatchEvent(accordeonEvt);
  window.dispatchEvent(formValidateEvt);
  updateFreeShippingBar(resultsMarkup);
  updateCartCount();
  
  if (openCartPanel) { showCartPanel(); }
}

function showCartPanel() {
  openPanel('cart');
}
function updateFreeShippingBar() {
    if (sideCartContainer.querySelector('.l4al.inline') != null) {
        document.querySelectorAll('.f8pr-free-shipping-bar').forEach(function (el) {
            el.innerHTML = sideCartContainer.querySelector('.l4al.inline').innerHTML;
            el.querySelectorAll('li.inv').forEach(function (em) {
                em.classList.remove('inv');
            });
        });
    }
}

function updateCartCount(count) {
    if (!count){
        count = document.querySelector('[data-totalqty]').dataset.totalqty;
    }
   

    countElement.innerHTML = count;
}

function handleCartUpdates(container) {
		var updateItemInput = container.querySelectorAll('input[name="updates[]"]'),
			removeItemLink 	= container.getElementsByClassName('remove-from-cart-link'),
				noteElement = container.querySelector('textarea[name="note"]'),
				submitButtons = container.querySelectorAll('.link-btn a, .link-btn button');

		Array.from(updateItemInput).forEach(function (input) {
			input.addEventListener('change', function (e) {
				updateItemQty(e.target, container);
			});
		});

		Array.from(removeItemLink).forEach(function (link) {
			link.addEventListener('click', function (e) {
				e.preventDefault();
				removeItem(e.target, container);
			});
		});

		if (noteElement) {
			// Debounced function to handle the input event
			const debouncedAddNote = debounce(async function (e) {
				try {
					await addNote(e.target, container);
					submitButtons.forEach(button => {
						button.disabled = false;
						button.classList.remove('disabled');
					});
					noteElement.focus();
				} catch (error) {
					console.error('Error:', error);
				}
			}, 1000);

			noteElement.addEventListener('input', function (e) {
				submitButtons.forEach(button => {
					button.disabled = true;
					button.classList.add('disabled');
				});
				debouncedAddNote(e);
			});
		}
		function debounce(func, delay) {
			let timeout;
			return function (...args) {
				clearTimeout(timeout);
				timeout = setTimeout(() => func.apply(this, args), delay);
			};
		}
	}


function updateItemQty(input, container) {
		line = parseInt(input.dataset.line),
			quantity = parseInt(input.value);
		config = {
			method: 'POST',
			body: JSON.stringify({
				'line': line,
				'quantity': quantity,
				'sections': 'side-cart,'+ cartPageTemplate
			}),
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/json',
				'Accept': 'application/javascript'
			}
		};
		fetch(routes.cart_change_url, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					handleErrorMessage(response.description);
					return;
				}
				if (container === sideCartContainer) {
					updateCartPanel(response);
				}
				if (cartPageContainer != null ) {
					updateCartPage(response);
					if (container != sideCartContainer) {
						updateCartPanel(response, false);
					}
				}
			})
			.catch((error) => {
				console.log("updateItemQty error", error);
			});
	};

	function removeItem(link, container) {
		line = parseInt(link.dataset.line);
		let item = link.closest('li');
		if (container === sideCartContainer || container == cartPageContainer) {
			if (item.querySelector('.removed') != null) {
				item.classList.add('processing');
			}
		}
		config = {
			method: 'POST',
			body: JSON.stringify({
				'line': line,
				'quantity': 0,
				'sections': 'side-cart,' + cartPageTemplate
			}),
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
				'Content-Type': 'application/json',
				'Accept': 'application/javascript'
			}
		};
		fetch(routes.cart_change_url, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					handleErrorMessage(response.description);
					return;
				}
				if (container === sideCartContainer || container == cartPageContainer) {
					if (item.querySelector('.removed') != null) {
						item.dispatchEvent(new CustomEvent("removing"));
						item.classList.add('removing');
						item.classList.remove('processing');
						item.querySelector('.removed a').addEventListener('click', function (e) {
							item.classList.add('processing');
							let tempForm = document.createElement('form');
							tempForm.innerHTML = '<input type="hidden" name="id" value="' + e.target.dataset.id + '"><input type="hidden" name="quantity" value="' + e.target.dataset.qty + '">';
							if (e.target.dataset.selling_plan) {
								tempForm.innerHTML += '<input type="hidden" name="selling_plan" value="' + e.target.dataset.selling_plan + '">';
							}
							for (var key in e.target.dataset) {
								if (key.indexOf('property-') === 0) {
									var data = JSON.parse(e.target.dataset[key]);
									tempForm.innerHTML += '<input type="hidden" name="properties[' + data[0] + ']" value="' + data[1] + '">';
								}
							}
							addCartItem(tempForm, item, container);
							tempForm.remove();
						});
					}
					if(container === sideCartContainer) {
						updateCartPanel(response, true);
						if (cartPageContainer != null) {
							updateCartPage(response);
						}
					} else if (container == cartPageContainer) {
						updateCartPage(response);
					}
				} else if (cartPageContainer != null ) {
					updateCartPage(response, true);
					updateCartPanel(response, false);
				}
			})
			.catch((error) => {
				console.log("removeItem error", error);
			});
	};

function openPanel(id) {
		const linked = document.querySelectorAll(`.m6pn[id="${id}"]`);
		const a_source = document.querySelectorAll(`a[data-panel="${id}"]`);

		overlayClose();
		asyncCSS();

		html_tag.classList.add('has-panels', 'm6pn-open');

		document.querySelectorAll('a[data-panel]').forEach(em => em.classList.remove('m6pn-clicked'));
		a_source.forEach(em => em.classList.add('m6pn-clicked'));
		Array.from(module_panel).forEach(function (el) {
			el.setAttribute('aria-hidden', true);
			if(!el.querySelector('.m6pn-close:not(.strong)')){
				append_url(el, 'Close', 'm6pn-close');
			}
			el.classList.remove('toggle');
			setTimeout(function () {
				negTabIn(el);
			}, 500);
			el.querySelectorAll('.l4pr.aside-pager').forEach(em => em.classList.remove('aside-pager'));
		});
		linked.forEach(el => {
			el.classList.add('toggle');
			el.setAttribute('aria-hidden', false);
			posTabIn(el);
			setTimeout(function () {
				el.querySelector('a, input, button, select, textarea, [role="button"]').focus();
				el.querySelectorAll('[style*="--fih:"]').forEach(slider => {
					const firstFig = slider.querySelector('.swiper-slide-active figure');
					if (firstFig) {
						if (firstFig.clientHeight === 0) {
							slider.style.removeProperty('--fih');
						} else {
							slider.style.setProperty('--fih', firstFig.offsetHeight + 'px');
						}
					}
				});
			}, 100);
		});
		if (document.getElementsByClassName('f8fl').length) {
			new_css('css-filters', window.filepaths['async_filters_css']);
			new_css('css-search', window.filepaths['async_search_css']);
		}
		getStickyFooters();
		new_css('css-panels', window.filepaths['async_panels_css']);
		if (linked[0].classList.contains('m6pr-compact')) {
			new_css('product-css', window.filepaths['page_product_css']);
		}
		if (linked[0].hasAttribute('data-delay')) {
			setTimeout(function () {
				hidePanels();
			}, parseFloat(linked[0].getAttribute('data-delay')));
		}

	}









